import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { Button, Tooltip, Typography } from '@mui/material'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { ModalDelDialog } from './ModalDelDialog'

type ItemButtonProps = {
  title: string
  id: string
  text: string
  onDel: (id: string) => void
}

export const ItemButton: React.FC<ItemButtonProps> = props => {
  const { title, text, id, onDel } = props
  const auth = useAuth()
  const [open, setOpen] = useState(false)
  const [isFocused, setIsFocused] = useState(false)

  const handleOpen = () => {
    setOpen(true)
    setIsFocused(true)
  }

  const handleClose = () => {
    setOpen(false)
    setIsFocused(false)
  }

  const handleDel = () => {
    onDel(id)
    handleClose()
  }

  const handleButtonBlur = () => {
    setIsFocused(false)
  }

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
  }

  const handleClick = () => {
    handleOpen()
    setIsFocused(true)
  }

  useEffect(() => {
    setIsFocused(false)
  }, [])

  return (
    <>
      {open && (
        <ModalDelDialog
          open={open}
          title={title}
          id={id}
          text={text}
          onClose={handleClose}
          onDel={handleDel}
        />
      )}
      <Button
        disabled={auth.isDisable}
        onBlur={handleButtonBlur}
        onClick={handleClick}
        onMouseEnter={handleFocus}
        onMouseLeave={handleBlur}
        sx={{
          marginBottom: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          // font: "normal normal normal 21px/32px Noto Sans JP",
          color: isFocused ? '#282828' : '#FFFFFF',
          backgroundColor: '#282828',
          '&:hover': {
            backgroundColor: 'rgba(241, 241, 241)',
            opacity: 0.8,
          },
          paddingTop: '6px',
          paddingLeft: '38px',
          textAlign: 'left',
          height: '80px',
          width: '400px',
          borderRadius: '40px',
        }}
      >
        <Tooltip title={text} enterTouchDelay={0}>
          <Typography
            sx={{
              textTransform: 'none',
              font: 'normal normal normal 21px/32px Noto Sans JP',
              fontSize: '21px',
              lineHeight: '32px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '340px',
            }}
          >
            {text}
          </Typography>
        </Tooltip>
        {isFocused && (
          <HighlightOffIcon
            sx={{
              color: 'red',
              mr: '32px',
              fontSize: '40px',
            }}
          />
        )}
      </Button>
    </>
  )
}
